/**
 * @license
 * Copyright Paysafe 2026. All rights reserved.
 */

export const FAQ_URL: string = 'https://www.paysafe.com/us-en/paysafewallet/support';
export const RETURN_URL_STORAGE_KEY: string = 'return-url';
